export default {
  stackedCardImageStyles: {
    'img-award-h90-61': 'award-badge-img-h90-h61',
    'img-award-h76-49': 'award-badge-img-h76-h49',
  },
  productListing: {
    card:
      'product-card flex-col justify-around h-full text-center sm:px-10 md:px-15 pdp-related',
    mediaWrapper: '',
    cardMedia: 'w-auto mx-auto md:mb-20 sm:mb-20 mdp:h-200 md:max-h-240',
    contentWrapper: 'flex flex-col justify-end h-full',
    cardContent:
      'pt-1 tracking-1 sm:text-sm md:text-base leading-normal font-light sm:pb-10 md:pb-0',
    heading:
      'sm:text-18 md:text-20 font-BebasNeueRegular text-black pb-6 md:pt-16 sm:pt-16 font-hairline related-prod-name',
    cardActions: 'px-6 py-1',
    header:
      'font-sans-bold block  text-black text-15 leading-normal pt-2 pb-2 pr-' +
      '4 pl-4',
    description:
      'font-BebasNeueRegular text-grey sm:text-14 md:text-16 leading-normal sm:pt-0 md:pt-0 md:mb-30',
    componentBox: 'component-box w-full',
    button: [
      'btn-primary font-sans-bold mb-15 text-center',
      'btn-secondary font-sans-bold text-center',
    ],
    buttonContainer: 'w-full',
    ratingWrapper: 'flex flex-wrap',
    ratingTextCount:
      'text-grey md:text-sm sm:text-xs inline-block items-center -mt-2px leading-normal font-thin pt-3',
  },
  ListingCard: {
    card:
      'product-card flex-col justify-around h-full text-center sm:px-10 md:px-15 pdp-related',
    mediaWrapper: '',
    cardMedia: 'w-auto mx-auto md:mb-20 sm:mb-20 mdp:h-200 md:max-h-240',
    contentWrapper: 'flex flex-col justify-end h-full',
    cardContent:
      'pt-1 tracking-1 sm:text-sm md:text-base leading-normal font-light sm:pb-10 md:pb-0',
    heading:
      'sm:text-18 md:text-20 font-BebasNeueRegular text-black pb-6 md:pt-16 sm:pt-16 font-hairline related-prod-name',
    cardActions: 'px-6 py-1',
    header:
      'font-sans-bold block  text-black text-15 leading-normal pt-2 pb-2 pr-' +
      '4 pl-4',
    description:
      'font-BebasNeueRegular text-grey sm:text-14 md:text-16 leading-normal sm:pt-0 md:pt-0 md:mb-30',
    componentBox: 'component-box w-full',
    button: [
      'btn-primary font-sans-bold mb-15 text-center',
      'btn-secondary font-sans-bold text-center',
    ],
    buttonContainer: 'w-full',
    ratingWrapper: 'flex flex-wrap',
    ratingTextCount:
      'text-grey md:text-sm sm:text-xs inline-block items-center -mt-2px leading-normal font-thin pt-3',
  },
  bannerReleatedCard: {
    card:'product-card flex-col justify-around w-full text-center sm:px-10 md:px-15 pdp-related story one',
  mediaWrapper: '',
  cardMedia: 'w-auto mx-auto my-10 md:h-130 md:max-h-130',
  contentWrapper: 'flex flex-col justify-end h-full',
  cardContent:
    'pt-1 tracking-1 sm:text-sm md:text-base leading-normal font-light sm:pb-10 md:pb-0',
  heading:'text-12 font-BebasNeueRegular text-black pb-6 md:pt-16 sm:pt-16 font-hairline related-prod-name',
  cardActions: 'px-6 py-1',
  header:
    'font-sans-bold block  text-black text-15 leading-normal pt-2 pb-2 pr-' +
    '4 pl-4',
    description:
    'font-BebasNeueRegular text-grey text-10 leading-normal sm:pt-0 md:pt-0 mb-0',
  componentBox: 'component-box w-full',
  button: [
    'btn-primary font-sans-bold mb-15 text-center',
    'btn-secondary font-sans-bold text-center',
  ],
  buttonContainer: 'w-full',
  ratingWrapper: 'flex flex-wrap',
  ratingTextCount:
    'text-grey md:text-sm sm:text-xs inline-block items-center -mt-2px leading-normal font-thin pt-3',
  },
storyReleatedCard:{
  card:
  'product-card flex-col justify-around w-full text-center sm:px-10 md:px-15 pdp-related story two',
mediaWrapper: '',
cardMedia: 'w-auto mx-auto my-10 md:h-130 md:max-h-130',
contentWrapper: 'flex flex-col justify-end h-full',
cardContent:
  'pt-1 tracking-1 sm:text-sm md:text-base leading-normal font-light sm:pb-10 md:pb-0',
heading:
  'text-12 font-BebasNeueRegular text-black pb-6 md:pt-16 sm:pt-16 font-hairline related-prod-name',
cardActions: 'px-6 py-1',
header:
  'font-sans-bold block  text-black text-15 leading-normal pt-2 pb-2 pr-' +
  '4 pl-4',
description:
  'font-BebasNeueRegular text-grey text-10 leading-normal sm:pt-0 md:pt-0 mb-0',
componentBox: 'component-box w-full',
button: [
  'btn-primary font-sans-bold mb-15 text-center',
  'btn-secondary font-sans-bold text-center',
],
buttonContainer: 'w-full',
ratingWrapper: 'flex flex-wrap',
ratingTextCount:
  'text-grey md:text-sm sm:text-xs inline-block items-center -mt-2px leading-normal font-thin pt-3',
}

};
